import React from 'react';
import './styles.scss';

const InputIcon = ({Icon, placeholder,name,type,required,customIcon}) => {

    return (
        <>
        <div className="Div">
        <Icon size = {19} className={`Div-Icon ${customIcon}`}/>
        <input placeholder={placeholder} required = {required} name = {name} type ={type}/>
        </div>
        </>


    )



}

export default InputIcon;
